import { useState, useEffect, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
// import { StarIcon } from "@material-ui/icons/Star";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import StarIcon from "@mui/icons-material/Star";
const InternshipDetails = () => {
  const [internship, setInternship] = useState({});
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const params = useParams();

  useEffect(() => {
    api
      .get(`/internships/by-id/${params?.internshipId}`)
      .then((res) => {
        console.log("internship>", res.data);
        setInternship(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  /********* */
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    internship?.userId &&
      api
        .get(`/user/getUserdataById/` + internship?.userId)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [internship]);
  /********* */

  const navigate = useNavigate();

  const deleteInternship = (i) => {
    api
      .delete(`/internships/${i?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your internships for violating terms and conditions.`,
            forAll: false,
            receiverId: i?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <Box className="container">
      <Card sx={{ width: "100%", marginTop: "20px" }}>
        <CardHeader
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar src={uploader?.profile} />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {uploader?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={uploader?.name?.toUpperCase()}
          subheader={new Date(internship?.createdAt).toDateString()}
        />
        <CardContent>
          <Grid container gap={4} sx={{ marginTop: "20px" }}>
            <Grid item xs={2}>
              <img
                src={internship?.companyLogoImage}
                style={{ width: "130px", height: "130px" }}
              />
            </Grid>
            <Grid item xs={8}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "600", color: "fontPrimaryColor.main" }}
                >
                  {internship?.generalData?.internshipTitle}
                </Typography>
              </Box>
              <Box sx={{ marginTop: "6px" }}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "400", color: "fontPrimaryColor.main" }}
                >
                  {internship?.generalData?.companyName} |{" "}
                  {internship?.generalData?.city},{" "}
                  {internship?.generalData?.state}
                </Typography>
              </Box>
              <Box sx={{ marginTop: "6px" }}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "400", color: "fontPrimaryColor.main" }}
                >
                  <CalendarMonthIcon
                    sx={{
                      fontSize: "1.2rem",
                      marginBottom: "5px",
                      marginRight: "5px",
                    }}
                  />
                  Apply till {internship?.generalData?.lastDateToApply}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container gap={3} sx={{ marginTop: "20px" }}>
            <Grid
              item
              xs={12}
              sm={5}
              sx={{ marginTop: "30px", paddingRight: "10px" }}
            >
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "600", marginBottom: "10px" }}
                >
                  Description
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    marginTop: "10px",
                    color: "fontPrimaryColor.main",
                    width: "100%",
                    height: "maxContent",
                    overflow: "hidden",
                  }}
                >
                  {internship?.generalData?.description}
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <Typography>Required Skills</Typography>
                <Box sx={{ display: "flex" }}>
                  {internship?.skills?.map((f) => (
                    <Typography
                      variant="body2"
                      sx={{
                        border: "1px solid lightgray",
                        width: "max-content",
                        padding: "2px 4px",
                        margin: "3px",
                        color: "colorThree.main",
                      }}
                    >
                      {f}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                marginTop: "20px",
                borderLeft: "1px dashed lightgray",
                padding: "30px 0",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                paddingLeft: "20px",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Industry
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.industry}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Internship Type
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.internshipType}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Duration
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.duration}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Number of positions
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.noOfPositions}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Stipend
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.stipend}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Working Hours
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.workingHours}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  City
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.city}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  State
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.state}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  Contact
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.contact}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  City
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.city}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ flex: "0.5", fontWeight: "600" }}>
                  State
                </Typography>
                <Typography sx={{ flex: "0.5" }}>
                  {internship?.generalData?.state}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}></Grid>
            <a
              className="asc__submit__form__button"
              href={internship?.generalData?.url}
              target="_blank"
              style={{
                marginLeft: "auto",

                textDecoration: "none",
              }}
            >
              Click to apply
            </a>
          </Grid>

          {/* <a href={internship?.generalData?.internshipLocationLink} target="_blank">
        See Live Location
      </a> */}

          <Box sx={{ marginTop: "30px" }}>
            {currentUser?.isAdmin ? (
              <button
                className=" asc__submit__form__button"
                onClick={() => deleteInternship(internship)}
              >
                Delete internship
              </button>
            ) : (
              <></>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default InternshipDetails;
